/* tslint:disable */
/* eslint-disable */
/**
 * PopshopLive API
 * PopshopLive API service
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    BatchSortReferralGifts,
    CreateReferralGiftRequest,
    CreateReferralGiftResponse,
    PatchReferralGiftRequest,
} from '../models';

export interface ReferralGiftApiControllerBatchSortReferralGiftRequest {
    batchSortReferralGifts: BatchSortReferralGifts;
}

export interface ReferralGiftApiControllerCreateRequest {
    createReferralGiftRequest: CreateReferralGiftRequest;
}

export interface ReferralGiftApiControllerDeleteRequest {
    referralGiftId: string;
}

export interface ReferralGiftApiControllerPatchRequest {
    referralGiftId: string;
    patchReferralGiftRequest: PatchReferralGiftRequest;
}

/**
 * 
 */
export class ReferralGiftApi extends runtime.BaseAPI {

    /**
     */
    async referralGiftApiControllerBatchSortReferralGiftRaw(requestParameters: ReferralGiftApiControllerBatchSortReferralGiftRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.batchSortReferralGifts === null || requestParameters.batchSortReferralGifts === undefined) {
            throw new runtime.RequiredError('batchSortReferralGifts','Required parameter requestParameters.batchSortReferralGifts was null or undefined when calling referralGiftApiControllerBatchSortReferralGift.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/referral-gifts:batchSort`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.batchSortReferralGifts,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async referralGiftApiControllerBatchSortReferralGift(requestParameters: ReferralGiftApiControllerBatchSortReferralGiftRequest): Promise<void> {
        await this.referralGiftApiControllerBatchSortReferralGiftRaw(requestParameters);
    }

    /**
     */
    async referralGiftApiControllerCreateRaw(requestParameters: ReferralGiftApiControllerCreateRequest): Promise<runtime.ApiResponse<CreateReferralGiftResponse>> {
        if (requestParameters.createReferralGiftRequest === null || requestParameters.createReferralGiftRequest === undefined) {
            throw new runtime.RequiredError('createReferralGiftRequest','Required parameter requestParameters.createReferralGiftRequest was null or undefined when calling referralGiftApiControllerCreate.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/referral-gifts`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.createReferralGiftRequest,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async referralGiftApiControllerCreate(requestParameters: ReferralGiftApiControllerCreateRequest): Promise<CreateReferralGiftResponse> {
        const response = await this.referralGiftApiControllerCreateRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async referralGiftApiControllerDeleteRaw(requestParameters: ReferralGiftApiControllerDeleteRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.referralGiftId === null || requestParameters.referralGiftId === undefined) {
            throw new runtime.RequiredError('referralGiftId','Required parameter requestParameters.referralGiftId was null or undefined when calling referralGiftApiControllerDelete.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/referral-gifts/{referralGiftId}`.replace(`{${"referralGiftId"}}`, encodeURIComponent(String(requestParameters.referralGiftId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async referralGiftApiControllerDelete(requestParameters: ReferralGiftApiControllerDeleteRequest): Promise<void> {
        await this.referralGiftApiControllerDeleteRaw(requestParameters);
    }

    /**
     */
    async referralGiftApiControllerPatchRaw(requestParameters: ReferralGiftApiControllerPatchRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.referralGiftId === null || requestParameters.referralGiftId === undefined) {
            throw new runtime.RequiredError('referralGiftId','Required parameter requestParameters.referralGiftId was null or undefined when calling referralGiftApiControllerPatch.');
        }

        if (requestParameters.patchReferralGiftRequest === null || requestParameters.patchReferralGiftRequest === undefined) {
            throw new runtime.RequiredError('patchReferralGiftRequest','Required parameter requestParameters.patchReferralGiftRequest was null or undefined when calling referralGiftApiControllerPatch.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/referral-gifts/{referralGiftId}`.replace(`{${"referralGiftId"}}`, encodeURIComponent(String(requestParameters.referralGiftId))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.patchReferralGiftRequest,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async referralGiftApiControllerPatch(requestParameters: ReferralGiftApiControllerPatchRequest): Promise<void> {
        await this.referralGiftApiControllerPatchRaw(requestParameters);
    }

}
